import SkillList from "./SkillList";
import './styles/skills.css'
import { LANGUAGES, FRAMEWORKS, TOOLS } from '../constants.js'
import useReveal from '../hooks/useReveal';


export default function Skills() {
  const ref = useReveal();

  return (
    <section ref={ref} id="skills" className="section">
      <h1 className="reveal">Skills {"{"}</h1>

      <div className="skills-container reveal-group">
        <SkillList title="Languages" skills={LANGUAGES} />
        <hr />
        <SkillList title="Frameworks" skills={FRAMEWORKS} />
        <hr />
        <SkillList title="Tools and Technologies" skills={TOOLS} />
      </div>

      <h1 className="reveal">{"}"}</h1>
    </section>
  );
}
